import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GlobalHelper } from '../Common/global.service';

@Injectable({
  providedIn: 'root'
})
export class GeneralPaymentService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // Particular

  GetAllParticular(): Observable<any> {
   
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl
      + 'GeneralPayment/GetAllParticular'
      , { headers: reqHeader });
  }

  SaveParticular(objModel): Observable<any> {
    let param = 'strParticular=' + objModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl
      + 'GeneralPayment/SaveParticular?'
      + encodeURI(param), { headers: reqHeader });
  }

  ParticularMarkActive(objModel): Observable<any> {
    let param = 'strParticular=' + objModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl
      + 'GeneralPayment/ParticularMarkActive?'
      + encodeURI(param), { headers: reqHeader });
  }

  // Customer

  GetAllCustomer(): Observable<any> {
   
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl
      + 'GeneralPayment/GetAllCustomer'
      , { headers: reqHeader });
  }

  SaveCustomer(objModel): Observable<any> {
    let param = 'strCustomer=' + objModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl
      + 'GeneralPayment/SaveCustomer?'
      + encodeURI(param), { headers: reqHeader });
  }

 // General Payment

 SaveGeneralPayment(objModel): Observable<any> {
  let param = 'strGeneralPayment=' + objModel;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl
    + 'GeneralPayment/SaveGeneralPayment?'
    + encodeURI(param), { headers: reqHeader });
}

UpdateGeneralPayment(objModel): Observable<any> {
  let param = 'strGeneralPayment=' + objModel;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl
    + 'GeneralPayment/UpdateGeneralPayment?'
    + encodeURI(param), { headers: reqHeader });
}

GetAllGeneralPayment(objModel): Observable<any> {
  let param = 'strGeneralPayment=' + objModel;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl
    + 'GeneralPayment/GetAllGeneralPayment?'
    + encodeURI(param), { headers: reqHeader });
}


// General Payment Cancel

SaveCancelReceipt(objModel): Observable<any> {
  let param = 'strStudent=' + objModel;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl
    + 'GeneralPayment/SaveCancelReceipt?'
    + encodeURI(param), { headers: reqHeader });
}

// General Payment Receipt

GetGeneralPaymentReceipt(ReceiptNo): Observable<any> {
  let param = 'ReceiptNo=' + ReceiptNo;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl
    + 'GeneralPayment/GetGeneralPaymentReceipt?'
    + encodeURI(param), { headers: reqHeader });
}

}
